import { render, staticRenderFns } from "./selectComponent.vue?vue&type=template&id=9b0babb2&scoped=true&"
import script from "./selectComponent.vue?vue&type=script&lang=js&"
export * from "./selectComponent.vue?vue&type=script&lang=js&"
import style0 from "./selectComponent.vue?vue&type=style&index=0&id=9b0babb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0babb2",
  null
  
)

export default component.exports